import { render, staticRenderFns } from "./DxTaskOrders.vue?vue&type=template&id=17462b70&scoped=true&"
import script from "./DxTaskOrders.vue?vue&type=script&lang=js&"
export * from "./DxTaskOrders.vue?vue&type=script&lang=js&"
import style0 from "./DxTaskOrders.vue?vue&type=style&index=0&id=17462b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17462b70",
  null
  
)

export default component.exports